<template>

    <div class="globecity" :class="className">
        <div v-if="!focus" class="globecity_city">{{ city }}</div>
        <div class="globecity_content">
            <div v-if="focus" class="globecity_title" v-html="title"></div>
            <div v-else class="globecity_title" v-moving-line v-html="title"></div>
            <div class="globecity_abstract" v-html="abstract"></div>
            <div v-if="link" class="globecity_link">
                <a :href="`http://${link}`" target="_blank">
                    {{ link }}
                </a>
            </div>
            <!-- <ButtonMagnetic color="white"></ButtonMagnetic> -->
        </div>
    </div>

</template>

<script>
    import ButtonMagnetic from "./ButtonMagnetic";
    export default {
        name: 'Globecity',
        components: {ButtonMagnetic},
        props: ['id', 'city', 'title', 'abstract', 'cityPos', 'link', 'focus'],
        computed: {
            className: function(){
                if (this.focus == "true" ){
                    return 'globecity-'+this.id+' globecity-focus';
                }
                else {
                    return 'globecity-'+this.id+' globecity-'+this.cityPos;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .globecity{

        width: 330px;
        position: relative;
        display: flex;

        &-focus {
            text-align: center;

            .globecity {
                &_title {
                    font-size: 12rem;
                    font-weight: 300;
                }

                &_abstract {
                    font-size: 1.8rem;
                    margin-top: 0;
                }
            }
        }


        &:after{
            content: '';
            display: block;
            clear: both;
        }


        &-topRight{
            .globecity_city{
                right: 0;
                top: -120px;
            }
        }
        &-topLeft{
             .globecity_city{
                 left: 0;
                 top: -120px;
             }
        }
        &-bottomRight{
            .globecity_city{
                right: -110px;
                top: 120px;
            }
        }
        &-bottomLeft{
             .globecity_city{
                 left: -110px;
                 top: 120px;
             }
        }
        &-right{
            .globecity_city{
                right: -110px;
                top: 20px;
            }
        }
        &-left{
            .globecity_city{
                left: -125px;
                top: 40px;
            }
        }


        &_title{
            font-size: 3rem;
            font-weight: $FW-bold;
        }

        &_abstract{
            font-size: 1.6rem;
            margin: 2rem 0 0.5rem 0;
        }

        &_link {
            a {
            font-size: 1.6rem;
            font-weight: $FW-normal;
            margin: 0;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        &_city{
            font-family: $F-Montserrat;
            font-weight: $FW-bold;
            background-color: #000;
            color: #DDC0B5;
            width: 100px;
            height: 100px;
            line-height: 1.5em;
            border-radius: 100px;
            text-align: center;
            font-size: 1.4rem;
            text-transform: uppercase;
            margin-bottom:  $G-default;
            flex: 0 0 100px;
            margin-right: $G-default;
            display: flex;
            justify-content: center;
            align-items: center;

            @include breakpoint(lg){
                position: absolute;
                margin-bottom:  0;
                margin-right:  0;
            }
        }


        .buttonMagnetic{
            float: right;
        }

    }
</style>